<template lang="html">


    <!-- Sidebar -->
    <div class="border-right" id="sidebar-wrapper">
      <div class="header-sidebar" slot="header">
        <img src="../../../assets/UNODC-logo-full.png" alt="" width="200" />
      </div>
      <div class="list-group list-group-flush">
          <router-link to="/dashboard/CountryRepresentative/dashboard" class="list-group-item list-group-item-action bg-light">
            <i class="material-icons">home</i> Dashboard
          </router-link>
           
  <div class="mt-2">
     <div
          slot="header"
          class="list-group-item list-group-item-action"
          id="mybutton"
        >
          <i class="material-icons pr-1">chrome_reader_mode</i><b>Reports</b>
        </div>
        <router-link
          to="/dashboard/CountryRepresentative/allReports"
          class="list-group-item list-group-item-action"
          ><i class="material-icons pr-1">remove</i>Brief Report
        </router-link>
        <router-link
          to="/dashboard/CountryRepresentative/strategicReportCR"
          class="list-group-item list-group-item-action"
          ><i class="material-icons pr-1">remove</i>Startegic Report
        </router-link>
        
        <router-link
          to="/dashboard/CountryRepresentative/eventReportCR"
          class="list-group-item list-group-item-action"
          ><i class="material-icons pr-1">remove</i>Event-wise Report
        </router-link>
        <router-link
          to="/dashboard/CountryRepresentative/thematicAreaReportCR"
          class="list-group-item list-group-item-action"
          ><i class="material-icons pr-1">remove</i>Thematic Area Report
        </router-link>
        <router-link
          to="/dashboard/CountryRepresentative/statisticalReportCR"
          class="list-group-item list-group-item-action"
          ><i class="material-icons pr-1">remove</i>Statistical Report
        </router-link>
        <router-link
          to="/dashboard/CountryRepresentative/deepAnalytics"
          class="list-group-item list-group-item-action"
          ><i class="material-icons pr-1">remove</i>Deep Analytics
        </router-link>
       
      </div>
      <div @click="showAlert" class="version-container">
            <span class="version">UNODC Version {{ this.version }}</span><br />
            <span class="rights">&copy;{{currentYear}}. All Rights Reserved</span>
        </div>
       </div>
       
    </div>
   <!-- <button class="btn btn-primary" id="menu-toggle">Toggle Menu</button> -->
</template>

<script>
import axios from "axios";
import Swal from 'sweetalert2';


export default {

    data: () => ({
        active: true,
        basepath: process.env.VUE_APP_BASE_PATH,
        Counter: 0,
        version: '',
        releaseDate: '',
        htmlContent: "",
        currentYear: new Date().getFullYear()
    }),
    mounted() {
        this.unassignedTrainingsCount();
        axios.defaults.headers['Authorization'] = localStorage.getItem('token')
        const token = localStorage.getItem('token');
        if (!token) {
            this.$toasted.global.errorMsg('Please login again');
            localStorage.clear();
            this.$router.push("/");
            return;
        }

        // Decode token to check expiration
        const tokenData = JSON.parse(atob(token.split('.')[1]));
        const tokenExpiration = tokenData.exp * 1000; // Convert to milliseconds
        const currentTime = Date.now();
        
        if (currentTime > tokenExpiration) {
            this.$toasted.global.errorMsg('Session expired. Please login again');
            localStorage.clear();
            this.$router.push("/");
            return;
        }

        axios.defaults.headers['Authorization'] = token;
        const appVersion = localStorage.getItem("version")
        const currentUser = JSON.parse(localStorage.getItem("currentUser"))
        const userId = currentUser.id

        axios
            .get("https://tmisodc.org/live_version.php")
            .then(response => {
                   this.version = response.data.version_no;
                  //  this.releaseDate = response.data.releaseDate;
                   this.htmlContent = response.data.html;
                         if(response.data.version_no != appVersion){
                  this.showAlert()
                  axios
                     .put(process.env.VUE_APP_BASE_PATH + "/users/update-version",{
                         userId: userId,
                         versionNo: response.data.version_no
                     })
                }   
                localStorage.setItem("version",response.data.version_no)
                 
            });
    
        
    },
    methods: {

        openLoading() {
            this.$vs.loading({
                type: "material"
            });
        },
        closeLoading() {
            this.$vs.loading.close();
        },

        unassignedTrainingsCount: function unassignedTrainingsCount() {
            this.openLoading();
            axios
                .get(
                    process.env.VUE_APP_BASE_PATH +
                    "/program_officer/unassigned/count-training/" +
                    JSON.parse(localStorage.getItem("currentUser")).id

                )
                .then(response => {
                    if (response.data.unAuth) {
                        this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);

                    }
                    if (response.data.tokenExpired) {
                        this.$toasted.global.errorMsg(response.data.tokenExpired);
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);
                    }
                    this.closeLoading();

                    this.Counter = response.data?.unsignedTrainingCount;

                });
        },

        showAlert() {
            Swal.fire({
                title: `TMIS Updated To Version ${this.version}`,
                html: `<div style="margin-top: 10px; border-bottom: 1px solid #cccccc; width: 100%;"></div>
                        <div>${this.htmlContent}</div>`,
                icon: 'success',
                showCloseButton: false,
                showConfirmButton: true,
                confirmButtonText: 'Close',
                confirmButtonColor: '#00a6e4',
                width: '50em',
                willOpen: () => {
                    // Set inline styles on the popup
                    const swalPopup = document.querySelector('.swal2-popup');
                    if (swalPopup) {
                        swalPopup.style.height = '700px'; // Set fixed height
                        swalPopup.style.overflowY = 'auto'; // Enable vertical scrolling
                    }

                    // Set inline styles on the backdrop
                    const swalBackdrop = document.querySelector('.swal2-container');
                    if (swalBackdrop) {
                        swalBackdrop.style.background = 'rgba(0, 0, 0, 0.7)'; // Custom backdrop color
                    }

                    const swalIcon = document.querySelector('.swal2-icon');
                    if (swalIcon) {
                        swalIcon.style.margin = '0.4em auto 0.5em';
                    }
                }
            });
        }
    }
};
</script>

<style>
.con-vs-dropdown--menu {
    width: 16% !important;
}

.no-cascading>h3 {
    display: none !important;
}

.vs-dropdown--group-label {
    font-size: 20px !important;
}

.con-vs-dropdown--menu.vs-dropdown-menu.rightx.notHeight {
    left: 220px !important;
    top: 0px !important;
}

.con-dropdown--group-con-ul {
    border-left: transparent !important;
}

.vs-dropdown--item .vs-dropdown--item-link {
    padding: 0px !important;
    padding-left: 0px !important;
    padding-right: 0px !important;
}

.vs-dropdown--group.marginIcon {
    padding-right: 0px !important;
    padding-left: 0px !important;
}
</style><style scoped>
.vs-collapse {
    padding: 0px !important;
}

.vs-collapse-item--header {
    padding: 0px !important;
}

.version-container {
    width: 240px;
    position: relative;
    bottom: 2px;
    cursor: pointer;
    padding: 1px;
    text-align: center;
    max-width: 240px;
    position: fixed;
    bottom: 0;
    border-top: 1px solid rgba(0, 0, 0, 0.125);
}

.version {
    font-weight: bold;
    font-size: 1em;
    color: #333;
}

.rights {
    font-size: 0.9em;
    color: #777;
}

@media (min-width: 768px) {
    .sidebarx {
        display: block !important;
    }

    .vs-sidebar--background {
        z-index: 0 !important;
        background: transparent !important;
    }
}

@media (max-width: 768px) {
    .vs-sidebar--background {
        background: rgba(0, 0, 0, 0.2) !important;
    }
}

body {
    overflow-x: hidden;
}

.material-icons {
    font-size: 20px !important;
    vertical-align: bottom;
}

#sidebar-wrapper {
    min-height: 100vh;
    margin-left: -15rem;
    -webkit-transition: margin 0.25s ease-out;
    -moz-transition: margin 0.25s ease-out;
    -o-transition: margin 0.25s ease-out;
    transition: margin 0.25s ease-out;
}

#sidebar-wrapper .sidebar-heading {
    padding: 0.875rem 1.25rem;
    font-size: 1.2rem;
}

#sidebar-wrapper .list-group {
    width: 15rem;
}

#page-content-wrapper {
    min-width: 100vw;
}

#wrapper.toggled #sidebar-wrapper {
    margin-left: 0;
}

@media (min-width: 768px) {
    #sidebar-wrapper {
        margin-left: 0;
    }

    #page-content-wrapper {
        min-width: 0;
        width: 100%;
    }

    #wrapper.toggled #sidebar-wrapper {
        margin-left: -15rem;
    }
}

/* scrollbar css starts */
#sidebar-wrapper {
    overflow-y: auto;
}

/* Keep scrollbar size same, but visually hide it until hover */
#sidebar-wrapper::-webkit-scrollbar {
    width: 5px;
}

#sidebar-wrapper::-webkit-scrollbar-track {
    background: transparent;
}

#sidebar-wrapper::-webkit-scrollbar-thumb {
    background: transparent;
    border-radius: 50px;
}

#sidebar-wrapper:hover::-webkit-scrollbar-track {
    background: #f1f1f1;
}

#sidebar-wrapper:hover::-webkit-scrollbar-thumb {
    background: rgba(7, 167, 225);
}
</style>
